import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import 'utils/components/RevisionNumber/RevisionNumber.scss';
import styleConstants from '../variables.module.scss';
import './XAxisLabel.scss';
import { useDelayedHover } from '@instinet-analytics/core-lib';
import { useXAxisLabelTimeLine } from 'widgets/fillsGraph/axisLabel/useXAxisLabelTimeLine';

export type XAxisLabelProps = PropsWithChildren<{
    label?: string;
    className: string;
    top: number;
    left: number;
    boxLeft?: number;
    time: number;
}>;

const LEFT_PADDING = parseInt(styleConstants.revisionTickLeftPadding);

export default function XAxisLabel({
    className,
    label,
    top,
    left,
    boxLeft,
    children,
    time,
}: XAxisLabelProps) {
    const [onMouseEnter, onMouseLeave, isHovering] = useDelayedHover(0);

    const display =
        !label || label.length === 0
            ? undefined
            : isHovering
            ? label
            : label.substring(0, 1);

    useXAxisLabelTimeLine(boxLeft, time, isHovering, className);

    const boxStyle = boxLeft ? { left: boxLeft } : undefined;

    return (
        <div
            className={classNames('XAxisLabel', className)}
            style={{
                top,
                left: left - LEFT_PADDING,
            }}
        >
            <div className="tick" />
            <div style={boxStyle} className="box-container">
                {display && (
                    <div
                        className="label-box"
                        onMouseEnter={onMouseEnter}
                        onMouseLeave={onMouseLeave}
                    >
                        {display}
                    </div>
                )}
                {children}
            </div>
        </div>
    );
}
